// config/particle-config.js
const particlesConfig = (color, size) => ({
  particles: {
    number: {
      value: 100,
      density: {
        enable: true,
        area: 1080, // changed from value_area ➜ area
      },
    },
    color: {
      value: color,
    },
    shape: {
      type: 'circle',
      stroke: {
        width: 0,
        color: '#000000',
      },
      polygon: {
        sides: 5, // changed nb_sides ➜ sides
      },
      image: {
        src: 'img/github.svg',
        width: 100,
        height: 100,
      },
    },
    opacity: {
      value: 1,
      random: true,
      animation: {
        // changed anim ➜ animation
        enable: true,
        speed: 1,
        minimumValue: 0.5,
        sync: false,
      },
    },
    size: {
      value: size,
      random: { enable: true, minimumValue: 0.3 },
      animation: {
        // changed anim ➜ animation
        enable: false,
        speed: 4,
        minimumValue: 0.3,
        sync: false,
      },
    },
    links: {
      // changed line_linked ➜ links
      enable: false,
      distance: 150,
      color: '#ffffff',
      opacity: 0.4,
      width: 1,
    },
    move: {
      enable: true,
      speed: 1,
      direction: 'none',
      random: true,
      straight: false,
      outModes: {
        // changed out_mode ➜ outModes
        default: 'out',
      },
      attract: {
        enable: false,
        rotate: {
          x: 600,
          y: 600,
        },
      },
    },
  },
  interactivity: {
    detectsOn: 'canvas', // changed detect_on ➜ detectsOn
    events: {
      onHover: {
        enable: true,
        mode: 'bubble',
      },
      onClick: {
        enable: true,
        mode: 'repulse',
      },
      resize: true,
    },
    modes: {
      grab: {
        distance: 400,
        links: {
          opacity: 1, // changed line_linked ➜ links
        },
      },
      bubble: {
        distance: 250,
        size: 0,
        duration: 2,
        opacity: 0,
        speed: 3,
      },
      repulse: {
        distance: 400,
        duration: 0.4,
      },
      push: {
        quantity: 4, // changed particles_nb ➜ quantity
      },
      remove: {
        quantity: 2, // changed particles_nb ➜ quantity
      },
    },
  },
  detectRetina: true, // changed retina_detect ➜ detectRetina
});

export default particlesConfig;
